<template>
    <div class="product-card">
      <div class="product-badge" v-if="product.badge" :class="{ sale: product.badge === 'sale' }">
        {{ product.badge === 'sale' ? '-20%' : product.badge }}
      </div>
      <div class="product-image">
        <img :src="product.image" :alt="product.name">
        <div class="product-actions">
          <button class="btn-wishlist"><i class="fas fa-heart"></i></button>
          <button class="btn-quickview"><i class="fas fa-eye"></i></button>
        </div>
      </div>
      <div class="product-info">
        <h3>{{ product.name }}</h3>
        <div class="product-rating">
          <i v-for="star in 5" :key="star" 
            :class="getStarClass(star)" 
          ></i>
          <span>({{ product.reviewCount }})</span>
        </div>
        <div class="product-price">
          <span class="current-price">${{ product.price }}</span>
          <span class="old-price" v-if="product.oldPrice">${{ product.oldPrice }}</span>
        </div>
        <button class="btn-add-cart">Add to Cart</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ProductCard',
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      getStarClass(star) {
        const rating = this.product.rating
        if (star <= Math.floor(rating)) return 'fas fa-star'
        if (star === Math.ceil(rating) && rating % 1 > 0) return 'fas fa-star-half-alt'
        return 'far fa-star'
      }
    }
  }
  </script>
  
  <style scoped>
  .product-card {
    background-color: var(--white);
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    overflow: hidden;
    transition: var(--transition);
    position: relative;
  }
  
  .product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .product-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: var(--primary-color);
    color: var(--white);
    padding: 5px 10px;
    border-radius: var(--border-radius);
    font-size: 12px;
    font-weight: 600;
    z-index: 1;
  }
  
  .product-badge.sale {
    background-color: var(--error);
  }
  
  .product-image {
    position: relative;
    padding: 20px;
    background-color: var(--gray-light);
    text-align: center;
  }
  
  .product-image img {
    height: 200px;
    object-fit: contain;
  }
  
  .product-actions {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    opacity: 0;
    transition: var(--transition);
  }
  
  .product-card:hover .product-actions {
    opacity: 1;
  }
  
  .btn-wishlist, .btn-quickview {
    background-color: var(--white);
    color: var(--text-color);
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    transition: var(--transition);
  }
  
  .btn-wishlist:hover, .btn-quickview:hover {
    background-color: var(--primary-color);
    color: var(--white);
  }
  
  .product-info {
    padding: 20px;
  }
  
  .product-info h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    color: var(--text-color);
  }
  
  .product-rating {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #ffc107;
    font-size: 14px;
  }
  
  .product-rating span {
    color: var(--text-light);
    margin-left: 5px;
  }
  
  .product-price {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }
  
  .current-price {
    font-size: 18px;
    font-weight: 700;
    color: var(--primary-color);
  }
  
  .old-price {
    font-size: 14px;
    color: var(--text-light);
    text-decoration: line-through;
  }
  
  .btn-add-cart {
    width: 100%;
    padding: 10px;
    background-color: var(--primary-color);
    color: var(--white);
    border: none;
    border-radius: var(--border-radius);
    font-weight: 600;
    transition: var(--transition);
  }
  
  .btn-add-cart:hover {
    background-color: var(--primary-dark);
  }
  </style>